import * as React from "react"

import { cn } from "@/lib/utils"

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  onEnter?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, onKeyUp, ...props }, ref) => {
    React.useEffect(() => {
      const textarea = ref as React.MutableRefObject<HTMLTextAreaElement | null>
      if (textarea?.current) {
        const handleKeyUp = (e: KeyboardEvent) => {
          // 透传onKeyUp prop（如果有）
          if (onKeyUp) {
            // React的onKeyUp类型是React.KeyboardEvent，但原生事件是KeyboardEvent
            // 这里简单兼容：只传原生事件
            (onKeyUp as any)(e)
          }
        }
        
        textarea.current.addEventListener("keyup", handleKeyUp)
        
        return () => {
          if (textarea.current) {
            textarea.current.removeEventListener("keyup", handleKeyUp)
          }
        }
      }
    }, [onKeyUp, ref])

    return (
      <textarea
        className={cn(
          "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

Textarea.displayName = "Textarea"

export { Textarea }
